export const EMPTY_LENGTH = 0;

export const TOTAL_BILLABLE_HEADER_DISPLAY_NAME = 'Billable Total';

// queryKey
export const ACCOUNT_LIST_FOR_USAGE_DASHBOARD_QUERY_KEY = 'account-list-for-usage-dashboard';
export const USAGE_METRIC_SERIES_QUERY_KEY = 'usage-metric-series-query-key';
export const EI_USAGE_METRIC_SERIES = 'ei-usage-metric-series';
export const API_USAGE_METRIC_SERIES = 'api-usage-metric-series';
export const APP_USAGE_METRIC_SERIES = 'app-usage-metric-series';
export const NEXA_USAGE_SUMMARY_QUERY_KEY = 'nexa-usage-summary';

export const NO_PLAN_LIMIT_METRIC = [
  'IntervalMinutesPlayedWithAds',
  'AppTotalEvents',
  'AppSessions',
];
